const indexSearch = () => {

	const searchInput = document.getElementById("index-search");
  if (!searchInput) return; // Exit if the search input is not found

  const tableRows = document.querySelectorAll("tbody tr");
  // Les index d'admin rendent aussi une liste de cartes sous md (shared/_index_card).
  // Sans ceci, la recherche ne filtrerait que le tableau, invisible sur mobile.
  const cards = document.querySelectorAll("[data-index-card]");

  searchInput.addEventListener("keyup", function() {
    const query = this.value.toLowerCase();

    tableRows.forEach(row => {
      const cells = row.querySelectorAll("td");
      const match = Array.from(cells).some(cell => cell.textContent.toLowerCase().includes(query));
      if (match) {
        row.style.display = "";
      } else {
        row.style.display = "none";
      }
    });

    cards.forEach(card => {
      const match = card.textContent.toLowerCase().includes(query);
      card.style.display = match ? "" : "none";
    });
  });

};

export { indexSearch };
